// @ts-check
/** Look up a business's registered legal name, address and state from its GSTIN - used by
 * Billing settings, and meant to be reused wherever else a GSTIN gets typed in. */

import api from '../utils/apiClient';

const adminGstinLookupService = {
  /**
   * @param {string} gstin
   * @returns {Promise<{legal_name: string, address: string, state: string, status: string}>}
   */
  async lookup(gstin) {
    return api.get(`/api/admin/gstin-lookup/${encodeURIComponent(gstin)}`);
  },
};

export default adminGstinLookupService;
